//@flow
import {
  LOGIN_REQUESTING,
  LOGOUT,
  FETCH_RESET_PASSWORD,
  LOGIN_WITH_FACEBOOK_REQUESTING,
  LOGIN_CHANGE_PASSWORD,
  LOGIN_CHANGE_EMAIL,
  LOGOUT_STARTING,
} from "./constants";

type loginData = {
  email: string;
  password: string;
  route?: string;
};

// probleme ici => le login de l'app.js envois un authtoken et une route
// d'ailleur je ne vois pas ce que tu fais avec l'email et le password ^^ je trouve pas
export const loginRequest = (payload: loginData) => {
  return {
    type: LOGIN_REQUESTING,
    payload,
  };
};

// utilisé ?
export const loginWithFacebookRequest = payload => {
  return {
    type: LOGIN_WITH_FACEBOOK_REQUESTING,
    payload,
  };
};

// perturbant, certaine fonction envois un userId d'autre n'envois rien....
// dans le saga il récupère le userId... donc voir avec l'appel dans le fichier index.js dans "scenes/Coaching"
export const logout = payload => {
  return {
    type: LOGOUT_STARTING,
    payload,
  };
};

export const resetPassword = (payload: { email: string }) => {
  return {
    type: FETCH_RESET_PASSWORD,
    payload,
  };
};

export const changePassword = (payload: string) => {
  return {
    type: LOGIN_CHANGE_PASSWORD,
    payload,
  };
};

export const changeEmail = (payload: string) => {
  return {
    type: LOGIN_CHANGE_EMAIL,
    payload,
  };
};
